import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class SourceObjectAttributeLookupData {
    sourceObjects: Array<DropdownOptionIntegerId>;
    dataTypes: Array<DropdownOptionIntegerId>;
    dataClassificationDetails: Array<DropdownOptionIntegerId>;
}
